import { TemplateProperty } from 'src/lib/templates';
import Joi from 'joi';

export const changePasswordTemplate: TemplateProperty = {
  name: 'changePasswordInfo',
  type: {
    name: 'object',
    kind: [
      {
        name: 'password',
        type: { name: 'string' },
        label: 'Clave',
        validators: [
          {
            name: 'pattern',
            signature: ['^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{8,}$'],
            errorMessage:
              'La contraseña debe tener al menos una mayúscula, una minúscula, un número y un carácter especial.',
          },
          { name: 'min', signature: [6], errorMessage: 'La contraseña es muy corta. Usá al menos 6 caracteres.' },
          { name: 'max', signature: [20], errorMessage: 'La contraseña es muy larga. Usá hasta 20 caracteres como máximo.' },
          { name: 'empty', errorMessage: 'Completa este dato' },
        ],
      },
      {
        name: 'confirmPassword',
        type: { name: 'string' },
        label: 'Confirmar clave',
        validators: [
          {
            name: 'pattern',
            signature: ['^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{8,}$'],
            errorMessage:
              'La contraseña debe tener al menos una mayúscula, una minúscula, un número y un carácter especial.',
          },
          { name: 'empty', errorMessage: 'Completa este dato' },
          { name: 'min', signature: [6], errorMessage: 'La contraseña es muy corta. Usá al menos 6 caracteres.' },
          { name: 'max', signature: [20], errorMessage: 'La contraseña es muy larga. Usá hasta 20 caracteres como máximo.' },
          { name: 'valid', signature: [Joi.ref('password')] },
        ],
        options: { messages: { 'any.only': 'Ambas contraseñas deben ser iguales.' } },
      },
    ],
  },
};
